import { render, staticRenderFns } from "./ManageRoles.vue?vue&type=template&id=2b1d3b07"
import script from "./ManageRoles.vue?vue&type=script&lang=js"
export * from "./ManageRoles.vue?vue&type=script&lang=js"
import style0 from "./ManageRoles.vue?vue&type=style&index=0&id=2b1d3b07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports